// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__s8CjA","notes":"Notes_notes__2OZFZ","note":"Notes_note__1LXSj","markdown":"Notes_markdown__1L43m"};